module.exports = __webpack_public_path__ + "static/mockup_banner-min-0f9f8d9d724619d3ed85367a1e0c1cf0.png";